export default {
  stores: 'stores',
  types: 'types',
  brands: 'brands',
}



// WEBPACK FOOTER //
// ./src/pages/StoreLocator/constants/TabTypes.js